import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import moment from 'moment';
import {StorageKeysEnum} from '../../../enums/storage-key.enum';
import {TranslateService} from '@ngx-translate/core';
import {InternationalPaymentSuccessModel} from './international-payment-success.model';
import {AmountsUtilsService} from "../../utils/amounts-utils.service";

@Component({
  selector: 'app-lib-international-payment-success',
  templateUrl: './international-payment-success.component.html',
  styleUrls: ['./international-payment-success.component.scss']
})
export class InternationalPaymentSuccessComponent implements OnInit {

  today: string = ''
  @Input() translations: any
  @Input() paymentSuccessModel!: InternationalPaymentSuccessModel;
  isDateProgrammed: boolean = false;
  @Output() downloadPdfEvent: EventEmitter<any> = new EventEmitter<any>()
  @Output() closeSuccessModalEvent: EventEmitter<any> = new EventEmitter<any>()
  @Input() loading = false

  constructor(
    private translate: TranslateService,
    public  amountsUtilsService: AmountsUtilsService
  ) {

  }

  async ngOnInit() {
    const browserLang = this.translate.getBrowserLang();
    const sessionLang = sessionStorage.getItem(StorageKeysEnum.CURRENT_LANGUAGE)
    let lang: any = sessionLang ? sessionLang : (browserLang?.match(/es|en/) ? browserLang : 'es');
    // this.translate.use(lang)
    moment.locale(lang)
    this.today = lang == 'es' ? moment().format('D [de] MMMM [de] YYYY') : moment().format('MMMM D, YYYY');
  }

  downloadPdf() {
    this.downloadPdfEvent.emit()
  }

  closeModal() {
    this.closeSuccessModalEvent.emit();
  }

}
